(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 3835:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(5038);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ layouts_AppLayout; },
  "u": function() { return /* reexport */ layouts_JobLayout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./components/index.ts + 25 modules
var components = __webpack_require__(6560);
// EXTERNAL MODULE: ./lib/fetcher.ts
var fetcher = __webpack_require__(6819);
// EXTERNAL MODULE: ./node_modules/.pnpm/swr@1.3.0_react@18.2.0/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(6747);
;// CONCATENATED MODULE: ./layouts/AppLayout.tsx




var AppLayout = function(param) {
    var children = param.children;
    var ref = (0,dist/* default */.ZP)("/api/company", fetcher/* default */.Z), company = ref.data, error = ref.error;
    if (error) return null;
    if (!company) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Header */.h4, {
                company: company
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Footer */.$_, {
                company: company
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CookiesConsent */.FY, {})
        ]
    });
};
/* harmony default export */ var layouts_AppLayout = (AppLayout);

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
;// CONCATENATED MODULE: ./layouts/JobLayout.tsx



var JobLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container mx-auto px-2 lg:px-0 py-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-6 gap-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:col-span-4",
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:col-span-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* JobSidebar */.w0, {})
                })
            ]
        })
    });
};
/* harmony default export */ var layouts_JobLayout = (JobLayout);

;// CONCATENATED MODULE: ./layouts/index.ts




/***/ }),

/***/ 5038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6560);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6648);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7025);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);




var PAGE_COVER_BG_URL = "/images/backgrounds/Contact Page_Head.jpg";
var ContactContent = function(param) {
    var company = param.company;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-12 md:px-20 py-12 md:py-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .TextHeading */ .qd, {
                as: "h2",
                alignment: "top-left",
                className: "text-2xl leading-loose font-bold text-black mb-10",
                children: "ช่องทางการติดต่อ"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ContactItem */ .lh, {
                        icon: "fi-rr-map-marker",
                        iconClasses: "text-primary",
                        title: "ที่อยู่",
                        titleClasses: "text-lg",
                        subTitleClasses: "text-base",
                        element: company.address
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ContactItem */ .lh, {
                        icon: "fi-rr-phone-call",
                        iconClasses: "text-primary",
                        title: "เบอร์ติดต่อ",
                        titleClasses: "text-lg",
                        subTitleClasses: "text-base",
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "whitespace-pre-line text-base",
                            children: [
                                "สำนักงาน: ",
                                company.phone,
                                " ",
                                company.phone_ext ? "ต่อ ".concat(company.phone_ext) : null,
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                "มือถือ: ",
                                company.mobile_phone
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ContactItem */ .lh, {
                        icon: "fi-brands-facebook",
                        iconClasses: "text-primary",
                        title: "Facebook",
                        titleClasses: "text-lg",
                        subTitleClasses: "text-base",
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://www.facebook.com/PerfectHunterRecruitment/",
                            children: "Perfect Hunter Recruitment"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ContactItem */ .lh, {
                        icon: "fi-brands-line",
                        iconClasses: "text-primary",
                        title: "LINE@",
                        titleClasses: "text-lg",
                        subTitleClasses: "text-base",
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://lin.ee/O6jTuhz",
                            children: "Line Official"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ContactItem */ .lh, {
                        icon: "fi-rr-envelope",
                        iconClasses: "text-primary",
                        title: "อีเมล",
                        titleClasses: "text-lg",
                        subTitleClasses: "text-base",
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "mailto:".concat(company.email),
                            children: company.email
                        })
                    })
                ]
            })
        ]
    });
};
var AddressMap = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "google-maps-phr-address-wrapper border-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            height: "100%",
            id: "google-maps-phr-address",
            src: "https://maps.google.com/maps?q=perfect-hunter&t=&z=15&ie=UTF8&iwloc=&output=embed",
            frameBorder: "0",
            scrolling: "no",
            className: "w-full overflow-auto"
        })
    });
};
var ContactUs = function(param) {
    var company = param.company;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Page */ .T3, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "ติดต่อเรา - ".concat("บริษัทจัดหางาน เพอร์เฟค ฮันเตอร์ จำกัด")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Page.Header */ .T3.Header, {
                bgUrl: PAGE_COVER_BG_URL,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Page.Heading */ .T3.Heading, {
                    title: "ติดต่อเรา",
                    subTitle: "บริษัทจัดหางาน เพอร์เฟค ฮันเตอร์ จำกัด"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "px-3 sm:px-0 py-16 lg:py-24 bg-gray-light",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container mx-auto bg-white",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid grid-flow-row lg:grid-flow-col grid-cols-1 lg:grid-cols-2 auto-rows-fr lg:auto-cols-fr",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactContent, {
                                        company: company
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddressMap, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "px-3 sm:px-0 py-16 lg:py-24",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container mx-auto bg-gray-light",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ContactForm */ .t, {})
                        })
                    })
                ]
            })
        ]
    });
};
ContactUs.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_2__/* .AppLayout */ .L, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ContactUs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [110,483,560,774,888,179], function() { return __webpack_exec__(3835); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);